module.exports = __webpack_public_path__ + "img/badge-percent.eff0bb4b.svg";